import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { sbEditable } from '@storyblok/storyblok-editable';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import DealerFinder from '@/components/DealerFinder/DealerFinder';

import { closeOverlay, openOverlay } from '@/store/redux/actions/app';

import DealerOverviewInfo from './DealerOverviewInfo';
import Footer from '../OverlayFormFooter/OverlayFormFooter';

export interface DealerOverviewStoryblokProps {
  component: string;
  _uid: string;
  _editable?: string;
}

const DealerOverview: FC<
  React.PropsWithChildren<DealerOverviewStoryblokProps>
> = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const className = {
    wrapper: 'flex sm:flex-col lg:flex-row',
    leftContent: 'bg-green60 flex-1 sm:h-[240px] lg:flex-col lg:h-[720px]',
    title:
      'font-headline font-weight-bold text-headline1 text-purple80 sm:mb-60px sm:mt-60px sm:mx-15px lg:mt-[175px] lg:mx-60px',
    dealerFinderContent: 'overflow-scroll lg:h-[720px] lg:pt-[120px] lg:w-3/6',
    dealerFinder: 'sm:pb-60px sm:pt-60px sm:px-15px lg:px-60px',
  };

  const handleBackToSearch = () => {
    dispatch(closeOverlay());
  };

  const dealerMapOverlay = (dealer: SchemaTypes.Dealer) => {
    return {
      children: (
        <>
          <div>
            <DealerOverviewInfo
              dealerDetails={dealer}
              retailOpeningHours={dealer.retailOpeningHours ?? []}
              serviceOpeningHours={dealer.serviceOpeningHours ?? []}
              hasMap={true}
            />
          </div>
          <Footer
            buttonText={translate(
              intl,
              'ui.DEALER_OVERVIEW.OVERLAY.CLOSE_BUTTON'
            )}
            onButtonClick={handleBackToSearch}
          ></Footer>
        </>
      ),
    };
  };

  const openMapOverlay = (dealer: SchemaTypes.Dealer) => {
    dispatch(openOverlay(dealerMapOverlay(dealer)));
  };

  return (
    <div {...sbEditable(props)} className={className.wrapper}>
      <div className={className.leftContent}>
        <h1 className={className.title}>
          {translate(intl, 'ui.DEALER_OVERVIEW.TITLE')}
        </h1>
      </div>
      <div className={className.dealerFinderContent}>
        <div className={className.dealerFinder}>
          <DealerFinder
            onDealerSelect={(dealer: SchemaTypes.Dealer) =>
              openMapOverlay(dealer)
            }
            isDealerListType={false}
          />
        </div>
      </div>
    </div>
  );
};

export default DealerOverview;
